import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-detail',
  templateUrl: './public-detail.component.html',
  styleUrls: ['./public-detail.component.scss']
})
export class PublicDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
